export const media = {
  smallBottom: '320px',
  smallTop: '568px',
  mediumBottom: '768px',
  mediumTop: '960px',
  largeBottom: '1024px',
  largeTop: '1280px',
  hugeBottom: '1440px'
};
